import type { Me } from "@contract/firm/me";
import { orgPlanKind } from "@contract/firm/plan";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { env } from "../env";

let posthogOn = false;

/** Error reporting and product analytics, each only when its key is set for this build. */
export function initObservability(): void {
  if (env.sentryDsn) {
    Sentry.init({ dsn: env.sentryDsn, environment: env.envLabel || "production" });
  }
  if (env.posthogKey) {
    posthog.init(env.posthogKey, {
      api_host: env.posthogHost,
      person_profiles: "identified_only",
      capture_pageview: true,
      autocapture: false,
    });
    posthogOn = true;
  }
}

/** Same person as the plugin: email is the distinct id, trimmed + lowercased (R22). */
export function identifyUser(email: string, me: Me): void {
  if (!posthogOn || !email) return;
  posthog.identify(email.trim().toLowerCase(), {
    org_id: me.orgId,
    org_plan: orgPlanKind(me.plan),
    firm_role: me.role,
    seat_count: me.seats.count,
  });
}

export function track(event: string, props: Record<string, string | number | boolean> = {}): void {
  if (posthogOn) posthog.capture(event, { surface: "web_panel", ...props });
}

export function resetAnalytics(): void {
  if (posthogOn) posthog.reset();
}
